export const logo = (color: string = "white") => (
  <svg
    id="RBK"
    data-name="RBK"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 950.0 650.0"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0, -5)">
      <path
        d="M966.46,221.52l90.51.17v-60c-75.91,16.32-147,49.44-211,89.9V611c0,21.82,10.38,44.61,28.49,62.53,17.95,17.78,40.56,28,62,28l120-.17h.5v-61l-90.75.17c-21.36,0-35.65-4.21-45-13.24C911.5,617.87,907,603.17,907,581V551l.21-256.6.22-16.84c-.24-23.66,2.93-36.56,10.94-44.53C926.86,224.58,941.25,221.12,966.46,221.52Z"
        transform="translate(-320.91 -160.46)"
        fill={color}
      />
      <path
        d="M1039,160.52H936.47c-21.57,0-44.31,10.44-62.4,28.63a107.57,107.57,0,0,0-10,11.61c62.6-22.31,125.34-35.77,187.26-40.12Z"
        transform="translate(-320.91 -160.46)"
        fill={color}
      />
      <path
        d="M761.12,312.27c-15.68,12.51-30.73,25.24-45.09,38a50.15,50.15,0,0,1,8.72,7.12c10.4,10.68,16.12,26.4,15.68,43.13L741.22,521v60c0,35.86-9.9,59.74-58.24,59.74h-29.5V409.84q-8.19,8.37-15.93,16.53c-15.76,16.63-30.8,33.31-45.07,49.85V701.76H713c22.28,0,45-10.43,62.45-28.61,17-17.78,26.79-40.43,26.79-62.13L802,521l-.59-90.5.87-30C802.28,358.9,789.55,331.52,761.12,312.27Z"
        transform="translate(-320.91 -160.46)"
        fill={color}
      />
      <path
        d="M653.48,221.76l30.25-.17c15.64.14,26.94,12.25,27.49,29.45,0,.33,0,12,0,22q30.25-17.88,60.86-33.08l0-18.93c.06-14.38-6.76-29.52-18.72-41.52s-27.2-19-41.68-19l-119.24.24v194q30.18-23.79,61-44.9Z"
        transform="translate(-320.91 -160.46)"
        fill={color}
      />
      <path
        d="M519.5,567.9c-15.64,21.34-29.62,41.66-41.82,60.41l23.68,73.21h61l-.16-.62C562,700,543,624.56,519.5,567.9Z"
        transform="translate(-320.91 -160.46)"
        fill={color}
      />
      <path
        d="M382.22,221.52h29.51c42.87-.35,57.36,14.12,59.49,59.5V401c0,41.06-2.35,59.6-10.2,74.14C483,452,506.71,428.59,532.23,405.6c0-1.18,0-2.32,0-3.41v-2.26l.07-28.91-.06-.5V251c0-22.6-10.3-45.65-28.25-63.25-17.66-17.32-40.35-27.25-62.25-27.25H321.22v496.1a919.94,919.94,0,0,1,61-89.2Z"
        transform="translate(-320.91 -160.46)"
        fill={color}
      />
      <path
        d="M1057,160.46h-.13c-84.5,7.06-170,31.2-254.15,71.77-73.59,35.47-145.89,83.29-214.89,142.12C455,487.54,363.07,617.2,321.27,700.8l-.36.72H412l.13-.29C468.75,582.67,737.29,219.67,1057,161.47v-1ZM397.9,579C475.27,472.94,589.19,357,727.2,273.82,588.15,358,474.26,475.1,397.9,579Z"
        transform="translate(-320.91 -160.46)"
        fill={color}
      />
    </g>
    <g transform="translate(-100, -35)">
      <text
        x="50%"
        y="100%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
        fontSize="62"
        fill={color}
        dy="17"
      >
        Rewards Bridge Consulting
      </text>
    </g>
  </svg>
);
